import { writable } from 'svelte/store';

// Store to track if the current received payment detail page shows a completed payment
export const isReceivedPaymentCompleted = writable<boolean>(false);

